import { Node as ProseMirrorNode, NodeType } from '@tiptap/pm/model';
import { Plugin, PluginKey } from '@tiptap/pm/state';
import { nanoid } from 'nanoid';

const isTargetNodeOfType = (node: ProseMirrorNode, type: any) => node.type === type;

const attrName = 'key';

export const UniqParagraphKeyPlugin = (isEditable: boolean) => {
  return new Plugin({
    key: new PluginKey('uniq-paragraph-key'),
    appendTransaction: (transactions, prevState, nextState) => {
      const tr = nextState.tr;
      if (!isEditable) return tr;

      let modified = false;
      if (transactions.some((transaction) => transaction.docChanged)) {
        const seenKeys = new Set<string>();

        // Adds a unique id to a node and ensures no duplicate keys exist
        nextState.doc.descendants((node: ProseMirrorNode, pos: number) => {
          const { paragraph, heading, codeBlock } = nextState.schema.nodes as { [key: string]: NodeType };
          if (
            isTargetNodeOfType(node, paragraph) ||
            isTargetNodeOfType(node, heading) ||
            isTargetNodeOfType(node, codeBlock)
          ) {
            const attrs = node.attrs;
            const existingKey = attrs[attrName];

            // Generate new key if node has no key OR if key is duplicate
            if (!existingKey || seenKeys.has(existingKey)) {
              tr.setNodeMarkup(pos, undefined, { ...attrs, [attrName]: nanoid() });
              modified = true;
            } else {
              seenKeys.add(existingKey);
            }
          }
        });
      }

      return modified ? tr : null;
    },
  });
};
